import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";

function BackButtonHandler() {
  useEffect(() => {
    console.log("✅ BackButtonHandler mounted");

    let removeListener;

    CapacitorApp.addListener("backButton", async () => {
      console.log("🔙 Android hardware back pressed");

      const shouldExit = window.confirm("Do you want to exit?");
      if (shouldExit) {
        CapacitorApp.exitApp();
      }
      // else do nothing
    }).then((listener) => {
      removeListener = listener.remove;
    });

    return () => {
      if (removeListener) removeListener();
    };
  }, []);

  return null;
}

export default BackButtonHandler;
